"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeIdentityFromConfig = void 0;
/**
 * Создает identity на основе информации из конфига
 *
 * Должны быть доступны настройки:
 * * projectName
 * * version.commit
 *
 * @export
 * @param {IConfig} config
 * @return {*}  {IMicrofrontendIdentity}
 */
function makeIdentityFromConfig(config) {
    return {
        mcs: config.getStrict('projectName'),
        version: config.getStrict('version.commit'),
    };
}
exports.makeIdentityFromConfig = makeIdentityFromConfig;
//# sourceMappingURL=makeIdentityFromConfig.js.map